import { Event, UserData } from '@bizzabo/entities';
import { useEffect } from 'react';
import { initGetFeedbackScript } from './getFeedbackScript';

declare global {
    interface Window {
        usabilla_live?: (key: string, data: unknown) => void;
    }
}

const ONE_WEEK_MILISECONDS = 7 * 24 * 60 * 60 * 1000;

const useGetFeedback = (user: UserData, event: Event, embedMode: boolean, extraData = {}) => {
    const { id, primaryEmail } = user ?? {};

    useEffect(() => {
        if (embedMode) {
            return;
        }

        const isValidUser = id && primaryEmail;
        if (isValidUser) {
            const initGetFeedback = async () => {
                await initGetFeedbackScript(primaryEmail);

                window.usabilla_live?.('data', {
                    custom: {
                        userId: id,
                        email: primaryEmail,
                        eventId: event?.id,
                        ...extraData,
                    },
                });

                window.usabilla_live?.('setEventCallback', function (_, action) {
                    if (action === 'Campaign:Success') {
                        const expires = new Date(Date.now() + ONE_WEEK_MILISECONDS).toUTCString();
                        document.cookie = 'campaign_complete=1; expires=' + expires + ';';
                    }
                });
            };

            initGetFeedback();
        }
    }, [id, primaryEmail]);
};

export default useGetFeedback;
